import {getIpClient, mantVisitas, mantDescCliente, registraClienteDesc, registraClienteSorteo} from "./rutaService"
import generalApi from "./generalApi"

export default {
    getIpClient() {
        return generalApi.getApi(getIpClient);
    },
    mantVisitas(params) {
        return generalApi.postApi(mantVisitas, params);
    },
    mantDescCliente(params) {
        return generalApi.postApi(mantDescCliente, params);
    },
    registraClienteDesc(params) {
        return generalApi.postApi(registraClienteDesc, params);
    },
    registraClienteSorteo(params) {
        return generalApi.postApi(registraClienteSorteo, params);
    },
}